







































import Vue from 'vue';
import upgradeVuex from '../vuex/common';
import { FansLevel, Time } from '../models/Fee';

export default Vue.extend({
  mixins: [upgradeVuex],
  data() {
    return {
      FansLevel,
      Time,
      percent: 25,
      dragable: false,
      oriX: 0,
    };
  },
  watch: {
    'accountState.fansLevel'() {
      this.selectLevel(this.accountState.fansLevel);
    },
  },
  methods: {
    selectLevel(level: number) {
      if (level >= this.accountState.fansLevel) {
        this.$store.commit('UPDATE_LEVEL', level);
        if (this.accountState.fansLevel === level && this.upgrade.time === Time.ZeroYear) {
          this.$store.commit('UPDATE_TIME', Time.OneYear);
        }
        this.setPercent(level);
      }
    },
    startDrag(event: any) {
      this.oriX = event.screenX;
      this.dragable = true;
    },
    setPercent(level: number) {
      switch (level) {
        case FansLevel.Level1:
          this.percent = 25;
          break;
        case FansLevel.Level2:
          this.percent = 50;
          break;
        case FansLevel.Level3:
          this.percent = 75;
          break;
        case FansLevel.Level4:
          this.percent = 100;
          break;
        default:
          break;
      }
    },
    dragSelectLevel(isNext: boolean) {
      switch (this.upgrade.level) {
        case FansLevel.Level1:
          if (isNext) {
            this.selectLevel(FansLevel.Level2);
          }
          break;
        case FansLevel.Level2:
          if (isNext) {
            this.selectLevel(FansLevel.Level3);
          } else {
            this.selectLevel(FansLevel.Level1);
          }
          break;
        case FansLevel.Level3:
          if (isNext) {
            this.selectLevel(FansLevel.Level4);
          } else {
            this.selectLevel(FansLevel.Level2);
          }
          break;
        case FansLevel.Level4:
          if (isNext) {
            this.selectLevel(FansLevel.Level4);
          } else {
            this.selectLevel(FansLevel.Level3);
          }
          break;
        default:
          break;
      }
    },
  },
  mounted() {
    this.selectLevel(this.accountState.fansLevel);
    window.document.body.addEventListener('mousemove', (event) => {
      if (this.dragable) {
        if (event.screenX > this.oriX + 20) {
          this.dragSelectLevel(true);
          this.dragable = false;
        }
        if (event.screenX < this.oriX - 20) {
          this.dragSelectLevel(false);
          this.dragable = false;
        }
      }
    });
    window.document.body.addEventListener('mouseup', () => {
      this.dragable = false;
    });
  },
});
